import React from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { BRAND_NAME, BRAND_URL } from '@/utils/constants';

const Footer = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Box
          display={'flex'}
          justifyContent={'space-between'}
          alignItems={'center'}
          width={1}
          flexDirection={{ xs: 'column', sm: 'row' }}
        >
          <Box
            display={'flex'}
            component="div"
            href={BRAND_URL}
            title={BRAND_NAME}
          >
            <Typography
              align={'center'}
              variant={'body1'}
              color="text.secondary"
            >
              {BRAND_NAME}
            </Typography>
          </Box>
          <Box display="flex" flexWrap={'wrap'} alignItems={'center'}>
            <Typography
              align={'center'}
              variant={'subtitle2'}
              color="text.secondary"
              gutterBottom
            >
              &copy; {BRAND_NAME}, {new Date().getFullYear()}. All rights
              reserved
            </Typography>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Footer;
